import React from 'react';
import styles from './CalendarDays.css';
import Day, { OnDaySelect, DayBaseProps } from '../Day/Day';

interface CalendarDaysProps extends CalendarDaysBaseProps {
  visibleDays: Date[];
  focusedDay: Date;
  selectedDay: Date;
  weekendDays: string[];
  onSelect: OnDaySelect;
}

export interface CalendarDaysBaseProps extends DayBaseProps {
}

export default function CalendarDays({
  visibleDays,
  selectedDay,
  focusedDay,
  weekendDays,
  onSelect,
  renderSelectedDay,
  renderWeekendDay,
  dayClasses,
  renderDay,
  renderOutsideOfMonth,
}: CalendarDaysProps) {
  return (
    <div className={styles.calendarDays}>
      {visibleDays.map((item: Date, index: number) => (
        <Day
          selectedDay={selectedDay}
          focusedDay={focusedDay}
          day={item}
          key={index}
          weekendDays={weekendDays}
          onSelect={onSelect}
          dayClasses={dayClasses}
          renderDay={renderDay}
          renderOutsideOfMonth={renderOutsideOfMonth}
          renderSelectedDay={renderSelectedDay}
          renderWeekendDay={renderWeekendDay}
        />
      ))}
    </div>
  )
}
